import { WarningErrorIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

import { useNotificationCenter } from "../NotificationCenter.context";

type Props = {
  title?: string;
  description?: string;
  retryLabel?: string;
};

export const NotificationCenterError = ({
  title = m.notificationCenter_errorTitle(),
  description,
  retryLabel = m.notificationCenter_errorRetry(),
}: Props) => {
  const { error, onRetry, isRetrying } = useNotificationCenter();

  if (!error) return null;

  const resolvedDescription =
    description ?? error.message ?? m.notificationCenter_errorDescription();

  return (
    <div
      className="flex flex-col items-center justify-center text-center py-10 px-6 gap-3"
      data-testid="notification-center-error"
      role="alert"
    >
      <WarningErrorIcon
        aria-hidden="true"
        className="h-8 w-8 text-text/secondary"
      />
      <p className="body-base-semibold text-text/primary">{title}</p>
      <p className="body-small-regular text-text/secondary">
        {resolvedDescription}
      </p>
      {onRetry ? (
        <ThemedButton
          dataTestId="notification-center-error-retry"
          disabled={isRetrying}
          onClick={onRetry}
          variant="secondary"
        >
          {retryLabel}
        </ThemedButton>
      ) : null}
    </div>
  );
};
